export default function Footer() {
  return (
    <footer id="footer" className="py-10 md:py-14 bg-secondary-900 text-secondary-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                尾
              </span>
              <span className="text-lg font-heading text-background-50">尾巴漫画</span>
            </div>
            <p className="text-sm text-secondary-400 leading-relaxed">
              免费漫画在线阅读平台，收录海量韩漫、日漫、国漫，支持下拉式阅读，追更不等待，好看漫画一网打尽。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-secondary-400 hover:text-background-50 transition-colors cursor-pointer no-underline">首页</a>
              <a href="#carousel" className="text-sm text-secondary-400 hover:text-background-50 transition-colors cursor-pointer no-underline">焦点专题</a>
              <a href="#cards" className="text-sm text-secondary-400 hover:text-background-50 transition-colors cursor-pointer no-underline">编辑力荐</a>
              <a href="#ranking" className="text-sm text-secondary-400 hover:text-background-50 transition-colors cursor-pointer no-underline">人气排行</a>
              <a href="#faq" className="text-sm text-secondary-400 hover:text-background-50 transition-colors cursor-pointer no-underline">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">漫画分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors cursor-pointer no-underline">热血战斗</a>
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors cursor-pointer no-underline">恋爱甜漫</a>
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors cursor-pointer no-underline">悬疑推理</a>
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors cursor-pointer no-underline">奇幻冒险</a>
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors cursor-pointer no-underline">完结漫画</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-secondary-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; 2026 尾巴漫画 weibamanga.com — 免费漫画在线阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-secondary-500 hover:text-background-50 transition-colors cursor-pointer no-underline">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#hero" className="text-secondary-500 hover:text-background-50 transition-colors cursor-pointer no-underline">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#hero" className="text-secondary-500 hover:text-background-50 transition-colors cursor-pointer no-underline">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}